var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "member-panel",
      class: _vm.isAvailable(_vm.member),
      on: {
        click: function($event) {
          return _vm.toggleDetails($event)
        }
      }
    },
    [
      _c("div", { staticClass: "member-name" }, [
        _vm._v("\n    " + _vm._s(_vm.nextAvailableDate(_vm.member)) + "\n\t\t"),
        _c(
          "b",
          {
            staticClass: "nameLink",
            on: {
              click: function($event) {
                return _vm.goToMember(_vm.member)
              }
            }
          },
          [_vm._v(_vm._s(_vm.member.first) + " " + _vm._s(_vm.member.last))]
        ),
        _vm._v(",\n\n\t\t\t"),
        _c("b", [_vm._v(_vm._s(_vm.memberLabelPrefix(_vm.member)))]),
        _c("b", { style: { color: "red" } }, [
          _c("i", [_vm._v(_vm._s(_vm.memberLabelEngagement(_vm.member)))])
        ]),
        _c("b", [
          _vm._v(_vm._s(_vm.memberLabelEngagementSeparator(_vm.member)))
        ]),
        _c("b", { style: { color: "red" } }, [
          _vm._v(
            _vm._s(
              Array.isArray(_vm.member.account_owner) &&
                _vm.member.account_owner.length > 0
                ? _vm.member.account_owner.join(", ")
                : ""
            )
          )
        ]),
        _c("b", [_vm._v(_vm._s(_vm.memberLabelSuffix(_vm.member)) + ",")]),
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.member.city) +
            " " +
            _vm._s(_vm.member.state) +
            ",\n\t\t\t" +
            _vm._s(
              _vm.member.roles.length > 0 && _vm.member.roles[0].trim() != ""
                ? _vm.member.roles + ", "
                : ""
            ) +
            _vm._s(_vm.member.organization) +
            "\n    "
        ),
        _vm.member.linkedIn
          ? _c(
              "a",
              { attrs: { href: _vm.member.linkedIn, target: "_blank" } },
              [
                _c("img", {
                  staticClass: "li-small",
                  attrs: {
                    src:
                      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Linkedin_icon.svg/1200px-Linkedin_icon.svg.png"
                  }
                })
              ]
            )
          : _vm._e(),
        _vm._v("  \n\n    "),
        !_vm.ask.recommendedAdvisors.includes(_vm.member._id)
          ? _c(
              "div",
              {
                staticClass: "add-match",
                attrs: { id: "addmatchbutton" },
                on: {
                  click: function($event) {
                    return _vm.addAdvisor(_vm.member)
                  }
                }
              },
              [_vm._v("\n        +Add\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.ask.recommendedAdvisors.includes(_vm.member._id)
          ? _c(
              "div",
              {
                staticClass: "remove-match",
                attrs: { id: "removematchbutton" },
                on: {
                  click: function($event) {
                    return _vm.removeAdvisor(_vm.member)
                  }
                }
              },
              [_vm._v("\n        Remove\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "score memberTotalScores" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.member.matchDetails.totalScore) + "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.member.matchDetails.selectionStrategies, function(strategy) {
        return _c(
          "span",
          { key: _vm.member._id + strategy[0] },
          [
            strategy[2] && strategy[2] > 0
              ? _c("clicker", {
                  staticStyle: { float: "right" },
                  attrs: {
                    mode: "dice",
                    value: strategy[2],
                    color: _vm.getDotColor(strategy[0]),
                    title: strategy[0]
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !(strategy[2] && strategy[2] > 0)
              ? _c(
                  "b",
                  {
                    staticClass: "strategy-dot",
                    style:
                      "float:right; color:#" + _vm.getDotColor(strategy[0]),
                    attrs: { title: strategy }
                  },
                  [_vm._v("⬤")]
                )
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "matched-terms" },
        _vm._l(_vm.matchedTags, function(match, idx) {
          return _c(
            "div",
            {
              key: match + idx,
              staticClass: "tagged-term",
              style: "color:" + match.dimension.color + ";"
            },
            [_vm._v("\n\t\t\t\t" + _vm._s(match.tag) + "\n\t\t\t")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.member.major1) +
            ", " +
            _vm._s(_vm.member.department1) +
            " " +
            _vm._s(_vm.member.school1) +
            "\n\t\t\t" +
            _vm._s(_vm.member.year1) +
            ". " +
            _vm._s(_vm.member.circles ? _vm.member.circles.join(",") : "") +
            "\n\t\t\t"
        ),
        _c("div", { staticStyle: { float: "right" } }, [
          _vm._v(_vm._s(_vm.statusLine()))
        ])
      ]),
      _vm._v(" "),
      _vm.showDetails
        ? _c(
            "div",
            { staticClass: "unmatched-terms" },
            [
              _vm._l(_vm.member.matchDetails.matchTerms, function(term) {
                return _c("div", { key: term, staticClass: "small-term" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(term) + " /\n\t\t\t")
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.unmatchedTags, function(match, idx) {
                return _c(
                  "div",
                  {
                    key: match + idx,
                    staticClass: "small-term",
                    style: "color:" + match.dimension.color + ";",
                    on: {
                      click: function($event) {
                        return _vm.addTerm(match)
                      }
                    }
                  },
                  [_vm._v("\n\t\t\t\t" + _vm._s(match.tag) + "\n\t\t\t")]
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-186946b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-186946b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gemini/TinyAdvisor.vue
// module id = null
// module chunks = 